/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DeliveryList } from '../../models/delivery-list';

export interface DeliveryControllerFind$Params {

/**
 * Sends 0 to remove limit
 */
  limit: number;
  skip: number;
  id?: Array<number>;
  maintenance_only_agreement?: boolean;

/**
 * true: solo le consegne di riparazione on center (seriale spedito al fornitore); false: le esclude
 */
  repair_on_center?: boolean;
  registry_id?: Array<number>;
  agreement_id?: Array<number>;
  order_customer_id?: number;
  delivery_status_id?: Array<number>;
  delivery_date_from?: string;
  delivery_date_to?: string;
  actual_delivery_date_from?: string;
  actual_delivery_date_to?: string;
  status_workflow_id?: Array<number>;
  ticket_numbers?: Array<number>;
  products_ids?: Array<number>;
  registry_end_customer?: Array<number>;
  registry_end_customer_address?: string;
  shipping_address_book_name?: string;
  office?: string;
  office_code?: string;
  order_identifiers?: Array<string>;
  courier_id?: number;
  external_ref_integration?: Array<string>;
  serial_numbers?: Array<string>;
  order_customer_external_ref?: string;
  order_by?: string;
  order_direction?: string;
}

export function deliveryControllerFind(http: HttpClient, rootUrl: string, params: DeliveryControllerFind$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DeliveryList;
}>> {
  const rb = new RequestBuilder(rootUrl, deliveryControllerFind.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('id', params.id, {});
    rb.query('maintenance_only_agreement', params.maintenance_only_agreement, {});
    rb.query('repair_on_center', params.repair_on_center, {});
    rb.query('registry_id', params.registry_id, {});
    rb.query('agreement_id', params.agreement_id, {});
    rb.query('order_customer_id', params.order_customer_id, {});
    rb.query('delivery_status_id', params.delivery_status_id, {});
    rb.query('delivery_date_from', params.delivery_date_from, {});
    rb.query('delivery_date_to', params.delivery_date_to, {});
    rb.query('actual_delivery_date_from', params.actual_delivery_date_from, {});
    rb.query('actual_delivery_date_to', params.actual_delivery_date_to, {});
    rb.query('status_workflow_id', params.status_workflow_id, {});
    rb.query('ticket_numbers', params.ticket_numbers, {});
    rb.query('products_ids', params.products_ids, {});
    rb.query('registry_end_customer', params.registry_end_customer, {});
    rb.query('registry_end_customer_address', params.registry_end_customer_address, {});
    rb.query('shipping_address_book_name', params.shipping_address_book_name, {});
    rb.query('office', params.office, {});
    rb.query('office_code', params.office_code, {});
    rb.query('order_identifiers', params.order_identifiers, {});
    rb.query('courier_id', params.courier_id, {});
    rb.query('external_ref_integration', params.external_ref_integration, {});
    rb.query('serial_numbers', params.serial_numbers, {});
    rb.query('order_customer_external_ref', params.order_customer_external_ref, {});
    rb.query('order_by', params.order_by, {});
    rb.query('order_direction', params.order_direction, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: DeliveryList;
      }>;
    })
  );
}

deliveryControllerFind.PATH = '/delivery';
